import styled from 'styled-components'

export const ModalHeaderWrapper = styled.div`
  position: relative;
  border: none;
  padding: 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.backgroundLite};
`

export const ModalHeaderTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  & * {
    text-align: center;
  }
`

export const ModalHeaderCloseIcon = styled.div`
  transition: 0.4s;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 20px;

  & svg {
    fill: ${({ theme }) => theme.colors.secondary};
  }
  & svg * path {
    fill: ${({ theme }) => theme.colors.secondary};
  }
  &:hover {
    transform: scale(1.2);
  }
`
